import nextCookies from 'next-cookies'
import { redirectToHome } from './redirect'
import { getCookieExpirationDate } from 'utils'

export const handleAuthentication = (nextCtx, shouldRedirect = false) => {
  const redirectTo = shouldRedirect ? nextCtx.pathname : '/'
  if (!isUserLogged(nextCtx)) {
    redirectToHome(redirectTo, nextCtx.res)
  }
}

export const isUserLogged = (nextCtx) => {
  const ctx = nextCtx || { req: {} }
  const cookies = nextCookies(ctx)
  return isValidSession(cookies.authCookie) || isValidSession(cookies.cobasiSession) || isValidSession(cookies.VtexIdclientAutCookie_cobasi) || isValidSession(cookies['X-Cobasi-User'])
}

function isValidSession (session) {
  return !!(session && session !== 'null' && session !== 'undefined')
}

export const getCobasiSessionCookie = ({ token, expiresAt } = {}, document) => {
  const isValid = document && token !== 'null'
  const cookieDomain = process.env.ENV && process.env.ENV !== 'development' ? 'domain=cobasi.com.br;' : ''
  const maxAge = token === '' ? ' Max-Age=-99999999; ' : ''
  isValid && (document.cookie = `cobasiSession=${token}; expires=${getCookieExpirationDate(expiresAt)}; path=/; ${cookieDomain}${maxAge}`)
}

export const setAuthCookies = ({ authCookie, cobasiToken }) => {
  if (authCookie) {
    document.cookie = `authCookie=${authCookie.value}; expires=${getCookieExpirationDate()}; path=/;`
  }
  getCobasiSessionCookie(cobasiToken, document)
}
